export default __webpack_public_path__ + "static/media/6.939bcef1.webp";